import React from "react";
import { motion } from "framer-motion";
import { Spinner } from "reactstrap";

/**
 * Loader Component
 * Orange spinning loader with optional message
 */
const Loader = ({  message = "Loading..." }) => {
  return (
    <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="   loading-container"
        >
          <Spinner color="primary" className="loading-spinner" />
          <p className="loading-text">{message}</p>
        </motion.div>
    
  );
};

export default Loader;
